import MessageSender from '../sender'
import BaseMessage from '../message'

export default (path, page, sort, countPerPage, filters = [], queryParam, exportCsv = 0) =>
  async () => {
    const msg = new BaseMessage()
    msg.setPath(`data/${path}`)
    msg.setItem('page', page)
    msg.setItem('limit', countPerPage)
    msg.setItem('sort', sort)
    if (filters.length > 0) {
      msg.setItem('filters', filters)
    }
    msg.setItem('param', queryParam)
    msg.setItem('exportCsv', exportCsv)

    const response = await new MessageSender().doGet(msg)

    if (exportCsv) {
      return response
    }

    if (response.isOK()) {
      return response.getResultAsObject()
    }

    return {}
  }
